// extracted by mini-css-extract-plugin
export var addWidgetButton = "_13-6";
export var backButton = "_13-1";
export var legacyWidgetContainer = "_13-5";
export var pageContainer = "_13-2";
export var settingsContent = "_13-0";
export var widgetSubsectionItem = "_13-3";
export var widgetSubsectionItemContent = "_13-4";